import { ITheme, IStyle, mergeStyleSets, getTheme, FontIcon } from '@fluentui/react';
import React from 'react';
import { toColor, toRgbaFunctionString } from '../../../../framework/utils/color';
import { xlate } from '../../../../framework/utils/i18n';

interface IPRIVATE_TIME_MONITOR_HEADER_EXPANDERProps {
  headerExpanded: boolean;
  onClicked: React.MouseEventHandler<HTMLButtonElement>;
}

const getStyleClasses = (theme: ITheme) => {

  const hoverColor = toColor(theme.palette.neutralQuaternary);
  hoverColor!.alpha = 80;

  const main: IStyle = {
    all: 'unset',
    width: '2em',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    color: theme.palette.white,
    cursor: 'pointer',

    '&:focus': {
      outline: `1px dashed ${theme.palette.white}`,
    },
    '&:hover': {
      backgroundColor: toRgbaFunctionString(hoverColor),
    },
    '&:active': {
      opacity: 1,
    }
  };

  const icon: IStyle = {
    fontSize: '1em',
  };

  return mergeStyleSets({
    main,
    icon,
  });
}

export const PRIVATE_TIME_MONITOR_HEADER_EXPANDER: React.FunctionComponent<IPRIVATE_TIME_MONITOR_HEADER_EXPANDERProps> = (props) => {
  const theme = getTheme();
  const styles = getStyleClasses(theme);

  return (
    <button
      className={styles.main}
      aria-label={props.headerExpanded ? xlate('Collapse discussion header') : xlate('Expand discussion header')}
      onClick={props.onClicked}
    >
      <FontIcon
        className={styles.icon}
        iconName={props.headerExpanded ? 'ChevronUp' : 'ChevronDown'}
        aria-hidden
      />
    </button>
  );
};
